<div [formGroup]="form" class="autocomplete mb-3">
  <label
    [class.field-invalid]="form.get(controlName)?.invalid && form.get(controlName)?.touched"
    [class.field-valid]="form.get(controlName)?.valid && form.get(controlName)?.touched && !isFocused(controlName)"
    [class.field-focused]="form.get(controlName)?.valid && isFocused(controlName)"
    for="controlName"
  >
    {{ label }}
  </label>

  <input
    class="form-control form-control-md"
    type="text"
    [formControlName]="controlName"
    (focus)="onFocus()"
    (blur)="onBlur()"
    placeholder="Escribe y selecciona una ciudad"
  />

  <ul *ngIf="showDropdown && filteredOptions.length > 0" class="dropdown">
    <li *ngFor="let option of filteredOptions" (mousedown)="selectOption(option)">
      {{ option }}
    </li>
  </ul>

  <div
    *ngIf="form.get(controlName)?.invalid && form.get(controlName)?.touched"
    class="text-danger danger-text"
  >
    <small *ngIf="isValidField(controlName)" class="maxwithalert" style="font-size: 14px;">
      Asegúrate de llenar este campo
    </small>
  </div>
</div>
